import { render, staticRenderFns } from "./memoryBank.vue?vue&type=template&id=6bcb7272&scoped=true&"
import script from "./memoryBank.vue?vue&type=script&lang=js&"
export * from "./memoryBank.vue?vue&type=script&lang=js&"
import style0 from "./memoryBank.vue?vue&type=style&index=0&id=6bcb7272&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcb7272",
  null
  
)

export default component.exports